'use client';

import posthog from 'posthog-js';

const MAX_BUFFERED_EXCEPTIONS = 10;

type ExceptionProperties = Record<string, unknown>;
type BufferedException = {
  error: unknown;
  properties: ExceptionProperties;
};

let isCaptureReady = false;
let isCaptureDisabled = false;
// Error boundaries can render before Cookiebot and PostHog finish initializing.
const bufferedExceptions: BufferedException[] = [];

export function capturePostHogException(error: unknown, properties: ExceptionProperties) {
  if (isCaptureDisabled || window.Cookiebot?.consent?.statistics === false) {
    return;
  }

  if (isCaptureReady) {
    posthog.captureException(error, properties);
    return;
  }

  if (bufferedExceptions.length === MAX_BUFFERED_EXCEPTIONS) {
    bufferedExceptions.shift();
  }
  bufferedExceptions.push({ error, properties });
}

export function startPostHogExceptionCapture() {
  if (isCaptureDisabled) {
    return;
  }

  isCaptureReady = true;
  for (const { error, properties } of bufferedExceptions.splice(0)) {
    posthog.captureException(error, properties);
  }
}

export function pausePostHogExceptionCapture() {
  isCaptureReady = false;
  bufferedExceptions.length = 0;
}

export function disablePostHogExceptionCapture() {
  isCaptureDisabled = true;
  pausePostHogExceptionCapture();
}
